import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  card: {
    width: 300,
  },
  content: { paddingBottom: theme.spacing(0) },
}));
